import { Link } from "react-router-dom";
import { VENDOR_GROUPS, getBlurbs, getVisibility, listVendors } from "@hub";
import { AGENT_LOGIN_URL, BROKER_LOGIN_URL } from "../config";
import { useHubVisitor, withVisitor } from "../hubContext";

export default function ProHub() {
  const visitor = useHubVisitor();
  const visibility = getVisibility();
  const blurbs = getBlurbs();
  if (visibility.pro === false) {
    return (
      <article>
        <h1>Pro hub</h1>
        <p className="lead">This hub is hidden for now.</p>
      </article>
    );
  }
  const vendors = listVendors().filter((item) => item.audience === "pro");

  return (
    <article>
      <h1>Pro hub</h1>
      <p className="lead">{blurbs.pro}</p>
      <div className="card-grid">
        <section className="card">
          <h2>Vendors & tools</h2>
          <p>Office tools, associations, and templates live in the directory.</p>
          <p>
            <Link className="btn" to={withVisitor("/vendors/pro", visitor)}>
              Open pro vendors
            </Link>
          </p>
        </section>
        <section className="card">
          <h2>Associations</h2>
          <p>
            {vendors.filter((item) => item.group === "associations").map((item) => item.name).join(" · ") ||
              "Add association notes from admin Controls."}
          </p>
        </section>
        <section className="card">
          <h2>Templates</h2>
          <p>
            {VENDOR_GROUPS.pro.find((item) => item.id === "templates")?.label}: quiet office forms, not legal advice.
          </p>
        </section>
        <section className="card">
          <h2>Open the desk</h2>
          <p>
            <a href={BROKER_LOGIN_URL}>Broker login</a>
            {" · "}
            <a href={AGENT_LOGIN_URL}>Agent login</a>
          </p>
        </section>
      </div>
      <div className="card-grid">
        {vendors.map((item) => (
          <article key={item.id} className="card">
            <p className="muted">{item.group}</p>
            <h3>{item.name}</h3>
            <p>{item.summary}</p>
            <p>
              <Link to={withVisitor(`/vendors/${item.id}`, visitor)}>Vendor detail</Link>
            </p>
          </article>
        ))}
      </div>
    </article>
  );
}
